<div class="subbanner">
  <div class="container position-relative">
    <div class="subbanner__title">
      <h1 class="primary-title">Testimonials</h1>
    </div>
  </div>
</div>

<div class="container-fluid padding-section" >
  <div class="container">
    <div class="row">

      <div class="col-md-3" *ngFor="let item of testimonial">
        <div class="card testimonial-card" (click)="openDialog(item)">
          <div class="testimonial-card__img-box">
            <img class="profile-image" [src]="item.logo" [alt]="item.title" loading="lazy" width="286" height="70" />
          </div>
          <div class="card-body">
            <h2 class="card-title card-title2">{{item.title}}</h2>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm">Read more</button>
            </div>
          </div>

        </div>
      </div>
      <!-- <div class="col-md-3">
        <div class="card testimonial-card">

          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/DHL.gif"
              alt="raj fertilizers & chemicals" loading="lazy" />
          </div>
          <div class="card-body new-cad-sec">
            <h5 class="card-title">raj fertilizers & chemicals</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="col-md-3">
        <div class="card testimonial-card">

          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/Akhil1.png"
              alt="Akhil Bhartiya Sanskritik Sangh" loading="lazy" />
          </div>
          <div class="card-body new-cad-sec">
            <h5 class="card-title">Akhil Bhartiya Sanskritik Sangh</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>

        </div>
      </div> -->
      <!-- <div class="col-md-3">
        <div class="card testimonial-card">

          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/Akhil1.png"
              alt="Akhil Bhartiya Sanskritik Sangh" loading="lazy" />
          </div>
          <div class="card-body new-cad-sec">
            <h5 class="card-title">Akhil Bhartiya Sanskritik Sangh</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>

        </div>
      </div>
      <div class="col-md-3">
        <div class="card testimonial-card">

          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/DHL.gif"
              alt="raj fertilizers & chemicals" loading="lazy" />
          </div>
          <div class="card-body new-cad-sec">
            <h5 class="card-title">raj fertilizers & chemicals</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card testimonial-card">
          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/indigo.jpg" alt="Indoco Remedies"
              loading="lazy" />
          </div>
          <div class="card-body">
            <h5 class="card-title">Indoco Remedies</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>

        </div>
      </div>
      <div class="col-md-3">
        <div class="card testimonial-card">
          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/lionhead.jpg"
              alt="Lions Club of Bombay Vijay Nagar" loading="lazy" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              Lions Club of Bombay Vijay Nagar</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>

        </div>
      </div>
      <div class="col-md-3">
        <div class="card testimonial-card">
          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/soft.jpg"
              alt="School of Fashion Technology" loading="lazy" />
          </div>
          <div class="card-body">
            <h5 class="card-title">
              School of Fashion Technology</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm"   overflow: hidden;(click)="openDialog()">Read more</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card testimonial-card">
          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/hindware.png"
              alt=" HSIL Ltd.-Tiles Division (Mum.)" loading="lazy" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              HSIL Ltd.-Tiles Division (Mum.)</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>

        </div>
      </div>

      <div class="col-md-3">
        <div class="card testimonial-card">
          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/MIT.jpg"
              alt="MIT School of Business, Pune" loading="lazy" />
          </div>
          <div class="card-body">
            <h5 class="card-title">
              MIT School of Business, Pune</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>

        </div>
      </div>
      <div class="col-md-3">
        <div class="card testimonial-card">
          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/Philips.jpg"
              alt="Philips Light Dealers Association" loading="lazy" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              Philips Light Dealers Association</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>

        </div>
      </div>

      <div class="col-md-3">
        <div class="card testimonial-card">
          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/netsurf.png" alt="Netsurf Communications"
              loading="lazy" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              Netsurf Communications</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>

        </div>
      </div>

      <div class="col-md-3">
        <div class="card testimonial-card">
          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/coromandel.gif"
              alt="Coromandel International Ltd" loading="lazy" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              Coromandel International Ltd.</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>

        </div>
      </div>

      <div class="col-md-3">
        <div class="card testimonial-card">
          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/mifta.jpg" alt="Mahesh Manjrekar, MIFTA"
              loading="lazy" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              Mahesh Manjrekar, MIFTA</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>

        </div>
      </div>

      <div class="col-md-3">
        <div class="card testimonial-card">
          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/mifta (1).jpg" alt="Rahul Ranade, MIFTA"
              loading="lazy" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              Rahul Ranade, MIFTA</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>

        </div>
      </div>


      <div class="col-md-3">
        <div class="card testimonial-card">

          <div class="testimonial-card__img-box">
            <img class="profile-image" src="../../assets/img/testimonial-image/leo-safari.jpg" alt="Leo Safari"
              loading="lazy" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              Leo Safari</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="card testimonial-card">

          <div class="testimonial-card__img-box">
            <img class="profile-image" src="" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              The senior citizen association of pune central</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="card testimonial-card">

          <div class="testimonial-card__img-box">
            <img class="profile-image" src="" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              Mr. Senan & Group</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3">
        <div class="card testimonial-card">

          <div class="testimonial-card__img-box">
            <img class="profile-image" class="profile-image" src="../../assets/img/testimonial-image/Nirmal.gif"
              alt="Nirmal Bang Group" loading="lazy" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              Nirmal Bang Group</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-3">

        <div class="card testimonial-card">

          <div class="testimonial-card__img-box">
            <img class="profile-image" class="profile-image" src="../../assets/img/testimonial-image/Madhurangan.png"
              alt="Sakal - Maduranagan" loading="lazy" />
          </div>

          <div class="card-body">
            <h5 class="card-title">
              Sakal - Maduranagan</h5>
            <div class="col text-center testi-btn">
              <button type="button" class="testi-rm" (click)="openDialog()">Read more</button>

            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>